'use client';

import { usePathname } from 'next/navigation';
import { useRef } from 'react';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import useGoToRoute from 'src/hooks/useGoToRoute';
import { WithClassName } from 'src/utils/UtilityTypes';
import { cm } from 'src/utils/classNames';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import ScrollShadows from '../ScrollShadows';

const baseNavigationOptions = [
	{
		label: 'Explore & Compare',
		value: 'explore-compare',
	},
	{
		label: 'Borrow/Lend',
		value: 'borrow-lend',
	},

	{
		label: 'Amplify',
		value: 'amplify',
	},

	{
		label: 'dSOL Liquid Staking',
		value: 'dsol-liquid-staking',
	},
];

type EarnPageNavSectionProps = WithClassName;

export function EarnPageNavSection({
	className,
	id,
}: EarnPageNavSectionProps & { id?: string }) {
	const pathname = usePathname();
	const goToRoute = useGoToRoute();
	const scrollableRef = useRef<HTMLDivElement>(null);

	// Extract the current tab from the pathname
	const routePathChunk = pathname?.split('/')[2];
	const activeTab = routePathChunk ?? 'explore-compare';

	const handleTabChange = (tabValue: string) => {
		const newRoute = `/earn/${tabValue}`;
		goToRoute(newRoute);
	};
	const isMobile = useIsMobileScreenSize();

	if (isMobile) {
		return (
			<div id={id} className={cm('-mx-2', className)}>
				<ScrollShadows
					scrollableRef={scrollableRef}
					gradientFromClassName="from-main-bg w-[60px]"
				>
					<div
						ref={scrollableRef}
						className="hidden-scroll flex justify-start overflow-x-auto"
					>
						<Tabs
							className="w-fit"
							variant="primary"
							size="md"
							indicatorTrack
							activeTab={activeTab}
							options={baseNavigationOptions}
							onTabChange={handleTabChange}
							dataTestId="earn-nav-tabs"
							tabTestIdPrefix="earn-nav"
						/>
					</div>
				</ScrollShadows>
			</div>
		);
	}

	return (
		<div
			id={id}
			className={cm(
				'flex w-full justify-center border-b border-stroke-divider',
				className
			)}
		>
			<Tabs
				className="w-[596px]"
				variant="primary"
				size="lg"
				activeTab={activeTab}
				options={baseNavigationOptions}
				onTabChange={handleTabChange}
				dataTestId="earn-nav-tabs"
				tabTestIdPrefix="earn-nav"
			/>
		</div>
	);
}
